module.exports = __webpack_public_path__ + "static/media/leasPicOne.932c7dbe.jpeg";